const playerPlaceholder = () => {
    const reproductorPlaceholders = document.querySelectorAll('.bg-video-lazy');

    reproductorPlaceholders.forEach(reproductorPlaceholder => {
        const videoID = reproductorPlaceholder.dataset.video;
        const matterportID = reproductorPlaceholder.dataset.matterport;

        if (videoID) {
            reproductorPlaceholder.addEventListener('click', () => {
                reproductorPlaceholder.innerHTML = `
                    <iframe 
                        width="100%" 
                        height="100%" 
                        src="https://www.youtube.com/embed/${videoID}?autoplay=1&controls=0&loop=1&playlist=${videoID}"
                        title="Manantiales 360°"
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowfullscreen
                    ></iframe>
                    <lite-youtube videoid="${videoID}"></lite-youtube>`;
            });
        } else if (matterportID) {
            reproductorPlaceholder.addEventListener('click', () => {
                reproductorPlaceholder.innerHTML = `
                    <iframe 
                        width="100%" 
                        height="100%" 
                        src="https://my.matterport.com/show/?m=${matterportID}"
                        title="Manantiales 360°"
                        frameborder="0" 
                        allowfullscreen
                    ></iframe>`;
            });
        } else {
            console.error('No se proporcionó un ID válido o el ID es inválido para:', reproductorPlaceholder); 
        }
    });
};

export { playerPlaceholder };
